var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat_component"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Live chat')))]),_c('div',{staticClass:"chat_wrapper",attrs:{"id":_vm.blockId},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.sendOnEnter.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }